import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

//components
import Popup from "../popup/popup.component"

//assets
import slug, { topicSlug } from "../slug"
import Logo from "../../assets/logo.svg"

//styles
import * as Styled from "./navigation.styles"

class Navigation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      submenu: false,
      themenSubmenu: false,
      kontaktSubmenu: false,
      popupShow: false,
      curPathname: "",
    }
    this.timeOutId = null

    this.onBlurHandler = this.onBlurHandler.bind(this)
    this.onFocusHandler = this.onFocusHandler.bind(this)
  }

  componentDidMount() {
    this.setState({ curPathname: this.props.location.pathname })
  }

  static getDerivedStateFromProps(props, state) {
    if (props.location.pathname !== state.curPathname) {
      return {
        curPathname: props.location.pathname,
        popupShow: false,
      }
    }
    return null
  }

  onBlurHandler(str) {
    this.timeOutId = setTimeout(() => {
      this.setState({
        [str]: false,
      })
    })
  }

  // If a child receives focus, do not close the popover.
  onFocusHandler() {
    clearTimeout(this.timeOutId)
  }

  closePopup() {
    this.setState({ popupShow: false })
  }

  checkCurPath(path) {
    if (this.state.curPathname.replaceAll) {
      const s = this.state.curPathname.replaceAll("/", "")
      const temp = path.replaceAll("/", "")
      return s.localeCompare(temp) === 0 ? 1 : 0
    } else {
      return 0
    }
  }

  popupState(themen = false) {
    if (themen) {
      return Object.values(topicSlug).includes(this.state.curPathname)
    } else {
      return (
        [slug[0], slug[1], slug[2]].filter(
          s => s.localeCompare(this.state.curPathname) === 0
        ).length === 1
      )
    }
  }

  render() {
    return (
      <Styled.Container role="navigation" aria-label="Seitennavigation">
        <Link
          to="/"
          className="nav__logo-container"
          tabIndex="-1"
          aria-label="SPÄTSOMMER GmbH"
        >
          <Logo />
        </Link>
        <Styled.MainList>
          <li>
            <Styled.GatsbyLink active={this.checkCurPath("/")} to="/">
              Startseite
            </Styled.GatsbyLink>
          </li>
          <li>
            <Styled.LeistungenButton
              active={this.popupState()}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ")
                  this.setState({ submenu: !this.state.submenu })
              }}
              onClick={() => this.setState({ submenu: !this.state.submenu })}
              onBlur={() => this.onBlurHandler("submenu")}
              aria-haspopup="true"
              aria-expanded={"" + this.state.submenu}
            >
              Leistungen
            </Styled.LeistungenButton>
            <Styled.Submenu
              show={this.state.submenu}
              onBlur={() => this.onBlurHandler("submenu")}
              onFocus={this.onFocusHandler}
            >
              <li>
                <Styled.GatsbyLink
                  active={this.checkCurPath(slug[0])}
                  to={slug[0]}
                >
                  Wohngemeinschaft
                </Styled.GatsbyLink>
              </li>
              <li>
                <Styled.GatsbyLink
                  active={this.checkCurPath(slug[1])}
                  to={slug[1]}
                >
                  Tagesstätte
                </Styled.GatsbyLink>
              </li>
              <li>
                <Styled.GatsbyLink
                  active={this.checkCurPath(slug[2])}
                  to={slug[2]}
                >
                  Ambulante Pflege
                </Styled.GatsbyLink>
              </li>
            </Styled.Submenu>
          </li>
          <li>
            <Styled.LeistungenButton
              active={this.popupState(true)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ")
                  this.setState({ themenSubmenu: !this.state.themenSubmenu })
              }}
              onClick={() =>
                this.setState({ themenSubmenu: !this.state.themenSubmenu })
              }
              onBlur={() => this.onBlurHandler("themenSubmenu")}
              aria-haspopup="true"
              aria-expanded={"" + this.state.themenSubmenu}
            >
              Pflegethemen
            </Styled.LeistungenButton>
            <Styled.Submenu
              show={this.state.themenSubmenu}
              onBlur={() => this.onBlurHandler("themenSubmenu")}
              onFocus={this.onFocusHandler}
              bigger
            >
              <li>
                <Styled.GatsbyLink
                  active={this.checkCurPath(
                    topicSlug[
                      "moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld"
                    ]
                  )}
                  to={
                    topicSlug[
                      "moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld"
                    ]
                  }
                >
                  Finanzielle Unterstützung und Leistungen für die Pflege im
                  gewohnten Umfeld
                </Styled.GatsbyLink>
              </li>
              <li>
                <Styled.GatsbyLink
                  active={this.checkCurPath(
                    topicSlug["voraussetzungen-und-leistungen-der-pflegegrade"]
                  )}
                  to={
                    topicSlug["voraussetzungen-und-leistungen-der-pflegegrade"]
                  }
                >
                  Voraussetzungen und Leistungen der Pflegegrade
                </Styled.GatsbyLink>
              </li>
            </Styled.Submenu>
          </li>
          <li>
            <Styled.GatsbyLink active={this.checkCurPath(slug[3])} to={slug[3]}>
              Team
            </Styled.GatsbyLink>
          </li>
          <li>
            <Styled.GatsbyLink active={this.checkCurPath(slug[4])} to={slug[4]}>
              Karriere
            </Styled.GatsbyLink>
          </li>
          <li>
            <Styled.GatsbyLink
              active={this.checkCurPath("/kontakt")}
              to={"/kontakt"}
            >
              Kontakt
            </Styled.GatsbyLink>
          </li>
        </Styled.MainList>
        <Styled.Button
          onClick={() => this.setState({ popupShow: !this.state.popupShow })}
          visible={this.state.popupShow}
          aria-haspopup="true"
          aria-expanded={"" + this.state.popupShow}
        >
          <Styled.HamburgerMenuItems />
          <span>Menü</span>
        </Styled.Button>
        <Popup location={this.props.location} show={this.state.popupShow} />
        <Styled.KontaktIconWrapper>
          <Styled.KontaktButton
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ")
                this.setState({ kontaktSubmenu: !this.state.kontaktSubmenu })
            }}
            onClick={() =>
              this.setState({ kontaktSubmenu: !this.state.kontaktSubmenu })
            }
            onBlur={() => this.onBlurHandler("kontaktSubmenu")}
            aria-haspopup="true"
            aria-expanded={"" + this.state.submenu}
            aria-label="Kontaktinformationen"
          >
            <GatsbyImage
              image={getImage(this.props.data.adressbuchIcon)}
              alt=""
            />
          </Styled.KontaktButton>
          <Styled.Submenu
            show={this.state.kontaktSubmenu}
            onBlur={() => this.onBlurHandler("kontaktSubmenu")}
            onFocus={this.onFocusHandler}
            tabIndex="0"
          >
            <li>
              <Styled.KontaktIcon>
                <GatsbyImage
                  image={getImage(this.props.data.telefon)}
                  alt="Telefonnummer"
                />
              </Styled.KontaktIcon>
              <span>0911/8931 037 70</span>
            </li>
            <li>
              <Styled.KontaktIcon>
                <GatsbyImage
                  image={getImage(this.props.data.atZeichen)}
                  alt="Email"
                />
              </Styled.KontaktIcon>
              <span>hallo@spaetsommer.de</span>
            </li>
            <li>
              <Styled.KontaktIcon>
                <GatsbyImage
                  image={getImage(this.props.data.fax)}
                  alt="Faxnummer"
                />
              </Styled.KontaktIcon>
              <span>0911/8931 037 80</span>
            </li>
          </Styled.Submenu>
        </Styled.KontaktIconWrapper>
      </Styled.Container>
    )
  }
}

const Wrapper = props => {
  return (
    <StaticQuery
      query={graphql`
        {
          atZeichen: file(relativePath: { regex: "/atZeichen_weiß.png$/" }) {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          adressbuchIcon: file(relativePath: { regex: "/kontaktIcon.png$/" }) {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          fax: file(relativePath: { regex: "/fax_weiß.png$/" }) {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          telefon: file(relativePath: { regex: "/telefon_weiß.png$/" }) {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      `}
      render={data => <Navigation data={data} {...props} />}
    />
  )
}

export default Wrapper
